<template>

    <div id="personalized-game-editor">

        <section class="heading-section" data-aos="fade-in">
            <div class="mx-xl-4 py-2" style="display: flex">
                <div class="heading" style="padding: 0 15px;">
                    <a :href="'/personalized-games/' + personalizedGame.package_identifier + '#game_' + this.personalizedGame.game_identifier" class="back"></a>
                    <div class="title">{{ t.__('Edytuj grę personalizowaną') }}</div>
                </div>
                <div class="text-right d-flex align-items-center" style="padding: 0 15px;margin-left: auto">
                    <div class="game-name">{{ personalizedGame.package_name }}: {{ personalizedGame.name }}</div>
                    <div class="vip-small-icon"></div>
                </div>
            </div>
        </section>

        <div class="row">
            <div class="col-9 content-column">
                <div class="editor-card">
                    <div class="row">
                        <div class="col-6">
                            <div class="additional-settings">
                                <div class="column-heading">{{ t.__('Dodatkowe ustawienia') }}</div>
                                <div class="form-check" v-if="settings">
                                    <input class="form-check-input" type="checkbox" id="settings-hidden" v-model="settings.hidden">
                                    <label class="form-check-label" for="settings-hidden">{{ t.__('Ukryj grę na urządzeniu') }}</label>
                                </div>
                            </div>

                            <div class="column-heading">{{ t.__('Pola do edycji') }}</div>
                            <personalized-game-editor-node v-model="config" @input="saveStatus = 'to_save'"></personalized-game-editor-node>
                        </div>
                        <div class="col-6">
                            <div class="column-heading">{{ t.__('Podgląd gry i zapis') }}</div>
                            <div v-if="hasMockups">
                                <personalized-game-editor-mockup v-for="(mockup, index) in mockups" :key="index" :mockup-images="mockup.images"></personalized-game-editor-mockup>
                            </div>
                            <div class="validation-error" v-if="validationErrors">{{ t.__('Niektóre pola nie zostały wypełnione poprawnie.') }} <br>{{ t.__('Uzupełnij wymagane informacje i spróbuj ponownie.') }}</div>
                            <div class="saving-section">
                                <div class="save-status" :class="saveStatus">{{ savingText }}</div>
                            </div>
                            <div class="row">
                                <div class="col-6" style="padding-right: 7.5px;">
                                    <b-button class="save-button" block :variant="savingButtonVariant" @click="save(true)">{{ t.__('Zapisz i zostań') }}</b-button>
                                </div>
                                <div class="col-6" style="padding-left: 7.5px;">
                                    <b-button class="save-button" block :variant="savingButtonVariant" @click="save(false)">{{ t.__('Zapisz i wróć') }}</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3 pt-4 synchronize-column">

                <synchronization-column></synchronization-column>

            </div>
        </div>

    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditor',

    props: {
        personalizedGameInput: Object,
        configInput: Object,
        settingsInput: Object,
        synchronizationStatusInput: String,
        lastSynchronizationDateInput: String,
        totalDiskSpaceInput: Number,
        usedDiskSpaceInput: Number
    },

    data() {
        return {
            eventHub: window.eventHub,
            config: null,
            settings: null,
            personalizedGame: {},
            saveStatus: 'saved', // to_save, saving, saved
            validationErrors: false,

            synchronizationStatus: 'synchronized', // synchronized, pending, synchronizing, unsynchronized,
            lastSynchronizationDate: '---',
            totalDiskSpace: 0,
            usedDiskSpace: 0,


            // tmp
            hasProcessingVideos: false
        }
    },

    computed: {
        hasMockups() {
            return this.mockups.length > 0;
        },
        mockups() {
            return this._findMockups([], this.config);
        },
        savingText() {
            switch (this.saveStatus) {
                case 'to_save':
                    return t.__('Zmiany wymagają zapisania');
                case 'saving':
                    return t.__('Zapisywanie, proszę czekać...');
                case 'saved':
                    return t.__('Zmiany zostały zapisane');
                default:
                    return ''
            }
        },
        savingButtonVariant() {
            switch (this.saveStatus) {
                case 'to_save':
                    return 'warning';
                case 'saving':
                case 'saved':
                    return 'success';
                default:
                    return ''
            }
        },
        synchronizationButtonText() {
            switch (this.synchronizationStatus) {
                case 'synchronized':
                    return t.__('Urządzenie zaktualizowane');
                case 'pending':
                    return t.__('Oczekiwanie na synchronizację');
                case 'synchronizing':
                    return t.__('W trakcie aktualizacji');
                case 'unsynchronized':
                    return t.__('Zaktualizuj zmiany na urządzeniu');
                default:
                    return ''
            }
        },
        freeDiskSpace() {
            return Math.round(((this.totalDiskSpace - this.usedDiskSpace) + Number.EPSILON) * 100) / 100;
        }
    },

    beforeMount() {
        this.personalizedGame = this.personalizedGameInput;
        this.config = this.configInput;
        this.settings = this.settingsInput;
        this.synchronizationStatus = this.synchronizationStatusInput;
        this.lastSynchronizationDate = this.lastSynchronizationDateInput;
        this.totalDiskSpace = this.totalDiskSpaceInput;
        this.usedDiskSpace = this.usedDiskSpaceInput;

        console.log(this.config);
    },

    mounted() {

        this.eventHub.$on('personalized-game-editor-update-personalized-game' , (personalizedGame, config, settings, synchronizationStatus, lastSynchronizationDate, totalDiskSpace, usedDiskSpace) => {
            this.personalizedGame = personalizedGame;
            this.config = config;
            this.settings = settings;
            this.synchronizationStatus = synchronizationStatus;
            this.lastSynchronizationDate = lastSynchronizationDate;
            this.totalDiskSpace = totalDiskSpace;
            this.usedDiskSpace = usedDiskSpace;
        });

        window.setInterval(() => {
            if (this.hasProcessingVideos || this.synchronizationStatus === 'synchronizing') {
                axios.get('/personalized-games/get-personalized-game/' + this.personalizedGame.package_identifier + '/' + this.personalizedGame.game_identifier)
                    .then(response => {
                        this.eventHub.$emit('personalized-game-editor-update-personalized-game', response.data.personalized_game, response.data.config, response.data.settings, response.data.synchronization_status, response.data.last_synchronization_date, response.data.total_disk_space, response.data.used_disk_space, response.data.total_disk_space, response.data.used_disk_space);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }, 2000);

    },

    methods: {

        _findMockups(mockups, element) {
            if (element.type === 'mockup') {
                let images = [];
                element.children.forEach(childElement => {
                    images = this._findMockupImages(images, childElement);
                });
                mockups.push({
                    'name': element.name,
                    'images': images
                });
            }
            if (element.type === 'node') {
                element.children.forEach(childElement => {
                    mockups = this._findMockups(mockups, childElement);
                });
            }
            return mockups
        },

        _findMockupImages(mockupImages, element) {
            if (element.type === 'mockup_image') {
                if (element.link && this._findImageUrl(element.link, this.config)) {
                    element.url = this._findImageUrl(element.link, this.config);
                } else if (element.path) {
                    element.url = '/personalized-games/get-personalized-game-file/' + this.personalizedGame.package_identifier + '/' + this.personalizedGame.game_identifier + '/' + element.path + '?mockup-image=1';
                }
                mockupImages.push(element);
                return mockupImages;
            }
            if (element.type === 'node') {
                element.children.forEach(childElement => {
                    mockupImages = this._findMockupImages(mockupImages, childElement);
                });
            }
            return mockupImages;
        },

        _findImageUrl(link, element) {
            let linkParts = link.split('/');
            if (linkParts.length === 0) {
                return false;
            }
            if (linkParts.length === 1 && element.name === linkParts[0]) {
                if (element.type === 'image' && element.hasOwnProperty('value') && element.value !== null && element.value.hasOwnProperty('url')) {
                    return element.value.url;
                } else if (
                    element.type === 'list' &&
                    element.element.type === 'image' &&
                    element.elements.length > 0 &&
                    element.elements[0].hasOwnProperty('value') &&
                    element.elements[0].value !== null &&
                    element.elements[0].value.hasOwnProperty('url')
                ) {
                    return element.elements[0].value.url;
                }
                return false;
            }
            if (element.type === 'node') {
                linkParts.shift();
                for (const childElement of element.children) {
                    let result = this._findImageUrl(linkParts.join('/'), childElement);
                    if (result !== false) {
                        return result;
                    }
                }
            }
            return false;
        },

        save(stay) {

            // if (stay) {
            //     console.log(this.config);
            //     return;
            // }

            if (this.saveStatus === 'saving') {
                return;
            }

            this.saveStatus = 'saving';

            axios.put('/personalized-games/update-personalized-game/' + this.personalizedGame.package_identifier + '/' + this.personalizedGame.game_identifier, {
                config: this.config,
                settings: this.settings
            })
                .then(response => {
                    if (stay) {
                        window.location.reload();
                    } else {
                        window.location.replace('/personalized-games/' + this.personalizedGame.package_identifier + '#game_' + this.personalizedGame.game_identifier);
                    }
                })
                .catch(response => {
                    let data = response.response.data;
                    this.saveStatus = 'to_save';
                    if (data.errors && data.errors) {
                        this.eventHub.$emit('personalized-games-update-errors', data.errors);
                        this.validationErrors = true;
                    } else {
                        this.eventHub.$emit('personalized-games-update-errors', {});
                        this.validationErrors = false;
                    }
                });
        },

        synchronize() {
            if (this.hasProcessingVideos || this.synchronizationStatus === 'synchronizing') {
                return;
            }

            axios.post('/personalized-games/synchronize/' + this.personalizedGame.package_identifier + '/' + this.personalizedGame.game_identifier)
                .then(response => {
                    console.log(response);
                    this.eventHub.$emit('personalized-game-editor-update-personalized-game', response.data.personalized_game, response.data.config, response.data.settings, response.data.synchronization_status, response.data.last_synchronization_date, response.data.total_disk_space, response.data.used_disk_space);
                    this.synchronizationStatus = 'synchronizing';
                })
                .catch(error => {
                    console.log(error);
                    alert(t.__('Wystąpił błąd synchronizacji'))
                });
        }

    }

}
</script>

<style scoped>

.additional-settings {
    margin-bottom: 4rem;

    .title {
        color: white;
    }

    .form-check {
        margin: 0 !important;
    }
}

</style>
